// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:767px){.slide-box{width:100%}.mobile-items.flex-box{width:100%;transition:.3s;padding:0 9px}.mobile-items .year-td.mobile{padding:13px 0}.highlights-download-list.annual .tr.active .download-td .mobile-arrow{transform:rotate(-180deg)}.highlights-download-list.annual .tr .td:first-child{cursor:pointer}}", ""]);
// Exports
module.exports = exports;
